import { useSnackbar } from '@/hooks/useSnackbar';
import {
  // listarFilmesMaisAvaliadosSemana,
  listarRecomendacoes,
  listarRecomendacoesParceiros,
  // listarSeriesMaisAvaliadasSemana,
  recuperarConteudos,
} from '@/services/conteudoService';
import { registrarEvento } from '@/services/googleAnalytics';
import {
  Recomendacao,
  ConteudoRecomendacao,
} from '@/services/types/recomendacao';
import { TituloRetornoBusca } from '@/services/types/titulo';
import { useEffect, useRef, useState } from 'react';

function useRecomendadosPaginaHook() {
  const { mostrarSnackbar } = useSnackbar();

  const [
    filmesMaisAvaliadosSemana,
    // setFilmesMaisAvaliadosSemana
  ] = useState<ConteudoRecomendacao[]>();
  const [
    seriesMaisAvaliadasSemana,
    // setSeriesMaisAvaliadasSemana
  ] = useState<ConteudoRecomendacao[]>();

  const [
    carregandoFilmesMaisAvaliadosSemana,
    // setCarregandoFilmesMaisAvaliadosSemana,
  ] = useState(false);
  const [
    carregandoSeriesMaisAvaliadasSemana,
    // setCarregandoSeriesMaisAvaliadasSemana,
  ] = useState(false);

  const [listasRecomendacoes, setListasRecomendacoes] =
    useState<Recomendacao[]>();

  const [carregandoListasRecomendacoes, setCarregandoListasRecomendacoes] =
    useState(false);

  const [listasParceiros, setListasParceiros] = useState<Recomendacao[]>();

  const [carregandoListasParceiros, setCarregandoListasParceiros] =
    useState(false);

  const qtdCliquesMostrarMais = useRef(0);

  async function recuperarFilmesMaisAvaliadosSemana() {
    return;
    // try {
    //   setCarregandoFilmesMaisAvaliadosSemana(true);
    //   const filmesMaisAvaliados = await listarFilmesMaisAvaliadosSemana();
    //   setFilmesMaisAvaliadosSemana(filmesMaisAvaliados);
    // } catch (error: unknown) {
    //   if (error instanceof Error) {
    //     mostrarSnackbar({
    //       color: 'error',
    //       highContrast: true,
    //       mensagem: error.message ?? '',
    //       size: 1,
    //       variant: 'solid',
    //     });
    //   }
    // } finally {
    //   setCarregandoFilmesMaisAvaliadosSemana(false);
    // }
  }

  async function recuperarSeriesMaisAvaliadasSemana() {
    return;
    // try {
    //   setCarregandoSeriesMaisAvaliadasSemana(true);
    //   const seriesMaisAvaliadas = await listarSeriesMaisAvaliadasSemana();
    //   setSeriesMaisAvaliadasSemana(seriesMaisAvaliadas);
    // } catch (error: unknown) {
    //   if (error instanceof Error) {
    //     mostrarSnackbar({
    //       color: 'error',
    //       highContrast: true,
    //       mensagem: error.message ?? '',
    //       size: 1,
    //       variant: 'solid',
    //     });
    //   }
    // } finally {
    //   setCarregandoSeriesMaisAvaliadasSemana(false);
    // }
  }

  async function recuperarListasRecomendacoes() {
    try {
      setCarregandoListasRecomendacoes(true);
      const retornoListarRecomendacoes = await listarRecomendacoes();
      setListasRecomendacoes(retornoListarRecomendacoes);
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    } finally {
      setCarregandoListasRecomendacoes(false);
    }
  }

  async function recuperarListasParceiros() {
    try {
      setCarregandoListasParceiros(true);
      const retornoListarParceiros = await listarRecomendacoesParceiros();
      setListasParceiros(retornoListarParceiros);
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    } finally {
      setCarregandoListasParceiros(false);
    }
  }

  useEffect(() => {
    recuperarFilmesMaisAvaliadosSemana();
    recuperarSeriesMaisAvaliadasSemana();
    recuperarListasRecomendacoes();
    recuperarListasParceiros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [conteudos, setConteudos] = useState<TituloRetornoBusca[]>();
  const [carregandoConteudos, setCarregandoConteudos] = useState(false);

  const [busca, setBusca] = useState('');
  const [pagina, setPagina] = useState(1);
  const [ultimaPagina, setUltimaPagina] = useState(false);
  const [ultimoItem, setUltimoItem] = useState<unknown>();

  // eslint-disable-next-line no-undef
  const debounceTimeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    setCarregandoConteudos(true);
    setPagina(1);
    setConteudos([]);
    setUltimaPagina(false);
  }, [busca]);

  useEffect(() => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(async () => {
      try {
        registrarEvento('buscar_fichas', { busca: busca });
        setCarregandoConteudos(true);

        const {
          dados: { lista, ultimaPagina = 1 },
          ultimoCursor,
        } = await recuperarConteudos({
          filtroBusca: busca,
          pagina,
          ultimoItem,
        });

        setUltimoItem(ultimoCursor);

        setConteudos((prev) =>
          pagina === 1 || !prev?.length ? lista : [...prev, ...lista],
        );
        setUltimaPagina(pagina >= ultimaPagina);
      } catch (error) {
        console.error(error);
      } finally {
        setCarregandoConteudos(false);
      }
    }, 500);

    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busca, pagina]);

  function carregarMais() {
    qtdCliquesMostrarMais.current += 1;
    registrarEvento('recomendados_clique_mostrar_mais', {
      cliques: qtdCliquesMostrarMais.current,
    });
    return setPagina((p) => p + 1);
  }

  return {
    filmesMaisAvaliadosSemana,
    carregandoFilmesMaisAvaliadosSemana,
    seriesMaisAvaliadasSemana,
    carregandoSeriesMaisAvaliadasSemana,
    listasRecomendacoes,
    carregandoListasRecomendacoes,
    conteudos,
    carregarMais,
    carregandoConteudos,
    ultimaPagina,
    busca,
    setBusca,
    carregandoListasParceiros,
    listasParceiros,
  };
}

export type useRecomendadosPaginaHookTypeReturn = ReturnType<
  typeof useRecomendadosPaginaHook
>;

export default useRecomendadosPaginaHook;
